module.exports = __webpack_public_path__ + "static/media/3b1df013-4f40-4171-95be-c8a479f00ace 1.87f7cba3.png";